import { connect } from 'react-redux';

import View from './';

const mapStateToProps = state => ({ intl: state.intl });

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./js/views/system-view/container.js